<div class="progress-container">
    <div
        class="progress-bar"
        [style.width.%]="progressValue()"
        [style.backgroundColor]="color()"
    ></div>
</div>
